import { Box, Stack } from '@mui/material'
import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault'
import CheckIcon from '@mui/icons-material/Check'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CompareArrowsIcon from '@mui/icons-material/CompareArrows'
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox'
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation'
import CancelIcon from '@mui/icons-material/Cancel'

const TripleCheck = ({ value, onChange, disableOnChange }) => {
  const handleClick = () => {
    if (!disableOnChange) {
      if (value === null) onChange(true)
      if (value === true) onChange(false)
      if (value === false) onChange(true)
    }
  }
  return (
    <Box
      sx={{ cursor: 'pointer' }}
      onClick={handleClick}
      padding={0.5}
      display="flex"
    >
      {value === null && (
        <IndeterminateCheckBoxIcon color="disabled" fontSize="large" />
      )}
      {value === true && <CheckBoxIcon color="success" fontSize="large" />}
      {value === false && <CancelIcon color="error" fontSize="large" />}
    </Box>
  )
}

export default TripleCheck
